module.exports = __webpack_public_path__ + "img/Widget_card_headpics_EB_staff.5f62cf19.jpg";